import React, { useEffect, useState } from "react";
import excel_icon from "../../../Assets/icons/excel_icon.png";
import pdf_icon from "../../../Assets/icons/pdf_icon.png";
import setting from "../../../Assets/icons/setting.png";
import "./DragDiv.scss";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import GlobalFilter from "../HeaderDiv/HeaderDivComponents/SearchBoxesDiv/GlobalFilter";
import { ColumnManagement } from "../ColumnManagement/ColumnManagement";
import { SlOptionsVertical } from "react-icons/sl";

/**
 * Transform a header like "Company_code" to "Company Code"
 */
function transformHeader(header) {
  return header
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

function DragDiv(props) {
  const [data, setData] = useState([]);
  const [headerRow, setHeading] = useState([]);
  const [ModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setData(props.data || []);
  }, [props.data]);

  useEffect(() => {
    if (data.length > 0) {
      const headers = Object.keys(data[0]);
      setHeading(headers);
    } else {
      setHeading([]);
    }
  }, [data]);

  // Filter out columns you don't want (e.g., "_id")
  const filteredHeaders = headerRow.filter((h) => h !== "_id");

  const HandleClick = () => {
    setModalOpen(true);
  };
  const Closeformfunction = () => {
    setModalOpen(false);
  };

  const handleExcelClick = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    // Header & data styles
    const headerStyle = {
      font: { name: "Arial", size: 10, bold: true, color: { argb: "FFFFFFFF" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF666666" } },
      alignment: {
        indent: 4, // Adding indent as passing for header cells
        vertical: "middle",
        horizontal: "center",
        // wrapText: false, // Turn off wrapping for headers
      },
    };
    const dataStyle = {
      font: { name: "Arial", size: 10 },
      alignment: {
        indent: 2, //adding indent as padding for data cells
        vertical: "middle",
        horizontal: "left",
        wrapText: true, // Turn off wrapping for data cells
      },
    };

    // 1) Add HEADER row:
    const transformedHeaders = filteredHeaders.map((col) => transformHeader(col));
    const headerRowExcel = worksheet.addRow(transformedHeaders);
    headerRowExcel.eachCell((cell) => {
      Object.assign(cell, headerStyle);
    });

    // 2) Add DATA rows:
    data.forEach((rowData) => {
      const rowValues = filteredHeaders.map((col) => rowData[col]);
      const row = worksheet.addRow(rowValues);
      row.eachCell((cell) => {
        Object.assign(cell, dataStyle);
      });
    });

    // 3) Auto‐size columns (with min and max clamp)
    transformedHeaders.forEach((header, idx) => {
      let longest = header.length; // at least the header length
      data.forEach((row) => {
        const val = row[filteredHeaders[idx]]?.toString() ?? "";
        longest = Math.max(longest, val.length);
      });
      // clamp between e.g. 15 and 40
      const minWidth = 25;
      const maxWidth = 40;
      const finalWidth = Math.max(minWidth, Math.min(longest, maxWidth));
      worksheet.getColumn(idx + 1).width = finalWidth;
    });

    // Generate and save
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "TableData.xlsx");
  };

  const handlePDFClick = () => {
    const doc = new jsPDF("p", "pt");
    const pdfHeaders = filteredHeaders.map(transformHeader);
    const pdfBody = data.map((row) => filteredHeaders.map((col) => row[col]));

    doc.autoTable({
      head: [pdfHeaders],
      body: pdfBody,
      startY: 20,
      headStyles: {
        fillColor: "#666666",
        textColor: "#FFFFFF",
        fontStyle: "bold",
        halign: "center",
      },
      styles: {
        font: "helvetica",
        fontSize: 9,
        // By default, Autotable won't wrap if the cell is short enough
        // but you can tweak cellWidth or tableWidth if needed.
      },
      margin: { left: 20, right: 20 },
    });

    doc.save("TableData.pdf");
  };

  return (
    <div className="drag_div">
      <p>Drag a column header and drop it here to group by that column</p>
      <div id="icons_div">
        <GlobalFilter setglobelFilter={props.setglobelFilter} />

        <img
          onClick={() => {
            if (typeof props.onExportExcel === "function") {
              props.onExportExcel(data);
            } else {
              handleExcelClick();
            }
          }}
          alt="excel_icon"
          src={excel_icon}
        />
        <img onClick={handlePDFClick} alt="pdf_icon" src={pdf_icon} />

        {props.settings && <img className="settingIcon" onClick={HandleClick} alt="setting icon" src={setting} />}
        {props.options && <SlOptionsVertical onClick={props.hanleTableOptions} />}
        {props.options && ModalOpen && (
          <ColumnManagement show={ModalOpen} Closeformfunction={Closeformfunction} title={props.title} />
        )}
      </div>
    </div>
  );
}

export default DragDiv;
